import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useCurrentClientManager } from '../../context';
const getSwitchViewText = (requiredAccountLevel, requiredAccountLevelName) => {
    let switchViewText = '';
    if (requiredAccountLevelName) {
        switchViewText = `Switch to ${requiredAccountLevelName} to view this page`;
    }
    else {
        switch (requiredAccountLevel) {
            case 'entity':
                switchViewText = 'Select an entity from the account selector to view this page';
                break;
            case 'segment':
                switchViewText = 'Select a segment from the account selector to view this page';
                break;
            default:
                switchViewText = 'Switch to view this page';
        }
    }
    return switchViewText;
};
export const useIsBlockedHelper = (requiredAccountLevels) => {
    const { selectedAccountLevel, client, entity, actions: { changeView }, } = useCurrentClientManager();
    const history = useHistory();
    const isBlocked = useMemo(() => {
        return Boolean(requiredAccountLevels &&
            requiredAccountLevels.length > 0 &&
            !requiredAccountLevels?.includes(selectedAccountLevel));
    }, [requiredAccountLevels, selectedAccountLevel]);
    const requiredAccountLevel = useMemo(() => {
        return requiredAccountLevels ? requiredAccountLevels[0] : undefined;
    }, [requiredAccountLevels]);
    const requiredAccountLevelName = useMemo(() => {
        if (requiredAccountLevel === 'entity' && entity) {
            return entity.name;
        }
        if (requiredAccountLevel === 'client') {
            return client.name;
        }
        return undefined;
    }, [requiredAccountLevel, entity, client]);
    const switchToRequiredAccountLevel = useCallback(async (path) => {
        const newView = {
            client,
        };
        if (requiredAccountLevel === 'entity') {
            newView.entity = entity;
        }
        await changeView(newView);
        if (path) {
            history.push(path);
        }
    }, [changeView, requiredAccountLevel, entity, client, history]);
    const switchViewText = getSwitchViewText(requiredAccountLevel, requiredAccountLevelName);
    return {
        isBlocked,
        selectedAccountLevel,
        requiredAccountLevelName,
        requiredAccountLevel,
        switchToRequiredAccountLevel,
        switchViewText,
    };
};
